const pathnames = {
  dashboard: '/',
  notFound: '/404',
  tenants: '/tenants',
  tenantProfile: `/tenants/:id`,
  tenantProfileLicenses: `/tenants/:id/licenses`,
  tenantProfileSettings: `/tenants/:id/settings`,
  getTenantProfile: (id: string | number) => `/tenants/${id}`,
  getTenantProfileTab: (id: string | number, tab: string) =>
    `/tenants/${id}?tab=${tab}`,
}

export default pathnames
